import * as React from "react";
import * as ReactQuery from "react-query";
import * as uuid from "uuid";

import {
  BodyScrollControllerProvider,
  CustomerSessionProvider,
  JoinDrawerProvider,
  JoinFormProvider,
  LocalizationProvider,
  LoginFormProvider,
  OneTimePasswordProvider,
  PresenterForScrollProvider,
  ProminentErrorProvider,
} from "../Common";

import {
  ReactWishlistGuestDrawerProvider,
  ReactWishlistGuestFeaturesProvider,
  ReactWishlistGuestInitialStateProvider,
  ReactWishlistGuestLoginAppProvider,
  useReactWishlistGuestInitialState,
  useWishlistGuestAnalytics,
  WishlistGuestAnalyticsProvider,
} from "./providers";

import { Page } from "./Page";

const queryClient = new ReactQuery.QueryClient();

interface AppProps {
  mountElement: Element;
}

export const App: React.FunctionComponent<AppProps> = (props) => {
  const bodyScrollControllerGuid = React.useMemo(() => {
    return uuid.v4();
  }, []);

  return (
    <BodyScrollControllerProvider guid={bodyScrollControllerGuid}>
      <ReactQuery.QueryClientProvider client={queryClient}>
        <ProminentErrorProvider>
          <PresenterForScrollProvider>
            <ReactWishlistGuestInitialStateProvider
              mountElement={props.mountElement}
            >
              <ReactWishlistGuestFeaturesProvider>
                <LocalizationProvider>
                  <WishlistGuestAnalyticsProvider>
                    <ReactWishlistGuestLoginAppProvider>
                      <CustomerSessionProvider
                        useInitialState={useReactWishlistGuestInitialState}
                      >
                        <LoginFormProvider
                          useInitialState={useReactWishlistGuestInitialState}
                        >
                          <JoinFormProvider
                            useInitialState={useReactWishlistGuestInitialState}
                          >
                            <OneTimePasswordProvider
                              useInitialState={
                                useReactWishlistGuestInitialState
                              }
                              useAnalytics={useWishlistGuestAnalytics}
                            >
                              <JoinDrawerProvider>
                                <ReactWishlistGuestDrawerProvider>
                                  <Page />
                                </ReactWishlistGuestDrawerProvider>
                              </JoinDrawerProvider>
                            </OneTimePasswordProvider>
                          </JoinFormProvider>
                        </LoginFormProvider>
                      </CustomerSessionProvider>
                    </ReactWishlistGuestLoginAppProvider>
                  </WishlistGuestAnalyticsProvider>
                </LocalizationProvider>
              </ReactWishlistGuestFeaturesProvider>
            </ReactWishlistGuestInitialStateProvider>
          </PresenterForScrollProvider>
        </ProminentErrorProvider>
      </ReactQuery.QueryClientProvider>
    </BodyScrollControllerProvider>
  );
};
